// info
import Info from '@src/config/info';

import * as S from './styles';

export default function MobileFooter(props: any) {
  return (
    <S.MobileFooterContainer {...props}>
      <S.MobileFooterContainerTop>
        <S.FooterLogo />
      </S.MobileFooterContainerTop>
      <S.MobileFooterContainerMiddle>
        <S.MobileFooterTermList>
          <S.Text to={{ pathname: '/privacy' }}>개인정보처리방침</S.Text>
          <S.Text to={{ pathname: '/terms' }}>서비스 이용약관</S.Text>
        </S.MobileFooterTermList>
      </S.MobileFooterContainerMiddle>
      <S.MobileFooterContainerBottom>
        <S.MobileFooterContainerMiddleContent href="mailto:cccv@cccv.to">
          문의처 cccv@cccv.to
        </S.MobileFooterContainerMiddleContent>
        <S.MobileFooterCopyRight>
          COPYRIGHT(c)Province of KEYPLAY. ALL RIGHT RESERVED.
        </S.MobileFooterCopyRight>
      </S.MobileFooterContainerBottom>
    </S.MobileFooterContainer>
  );
}
